@if(component) {
<div class="w-12 center p-t-8 p-b-8">
    <div class="w-12 center wrap">
        <h3 class="m-t-7 m-t-0-s"
            *iCms="'title' of component"
            [ngClass]="component.title_font_style"
            text></h3>

        <div class="m-t-11 m-t-10-s"
             [grid]="[1, 2, 4, 4][client.sizeId]"
             [gridColumnGap]="[0, 4, 4, 4][client.sizeId]"
             [gridRowGap]="[8, 5, 5, 5][client.sizeId]">
            @for (item of pages; track item) {
            <cms-blog-component-more-stories-item [modelId]="item.page"></cms-blog-component-more-stories-item>
            }
        </div>

        @if (isBtnVisible) {
        <action class="button-2 m-t-8"
                (click)="loadMore()">
            <span>{{'View More' | translate}}</span>
        </action>
        }
    </div>
</div>
}